import { useMutation } from '@apollo/client/react';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import { MoveDocumentMutationDocument, MoveFolderMutationDocument } from './mutation.gql';
export function useMoveEntry() {
    const [folder, folderState] = useMutation(MoveFolderMutationDocument);
    const [document, documentState] = useMutation(MoveDocumentMutationDocument);
    const handler = (parentId, entryId, kind) => {
        const mutateHandler = kind === EntryKind.Folder ? folder : document;
        return mutateHandler({
            variables: { parentId, id: entryId, bundleVersion: process.env.PLEDITOR_BUNDLE_VERSION },
            update(cache, { data }) {
                const { entries } = data || {};
                const { __typename } = entries || {};
                const cacheId = cache.identify({ id: entryId, __typename });
                cache.modify({
                    id: cacheId,
                    fields: (_, { DELETE }) => DELETE,
                });
            },
        });
    };
    const error = folderState.error || documentState.error;
    const loading = folderState.loading || documentState.loading;
    return [handler, { error, loading }];
}
